jQuery( document ).ready( function( $ ) {
	$('.oab-two-column-quote-with-video__video').on('click', function (){
		$('.oab-two-column-quote-with-video__video-modal').toggle("show");
	});

	$(document).mouseup( function(e){

		if ( !$('.oab-two-column-quote-with-video__item').is(e.target) && $('.oab-two-column-quote-with-video__item').has(e.target).length === 0 ) {
			$('.oab-two-column-quote-with-video__video-modal').hide();
		}
	});
});

